export const SLOT_KEY = "__slot"

export function makeSlot(name: string) {
    const Slot = ({ children }: { children: React.ReactNode }) => children
        ; (Slot as any)[SLOT_KEY] = name
    return Slot
}
